import { Controller } from "@hotwired/stimulus"
import { getCableConsumer } from "../lib/cable"

export default class extends Controller {
  static targets = ["balance"]
  static values = { userId: Number }

  connect() {
    this.subscription = getCableConsumer().subscriptions.create(
      { channel: "UserChannel" },
      {
        received: (data) => {
          if (data.type === "balance_update") {
            this.updateBalance(data)
          }
        }
      }
    )
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  updateBalance(data) {
    this.balanceTargets.forEach(target => {
      // Поддерживаем как десктопную версию (с форматированием), так и мобильную (короткую)
      if (target.dataset.format === "short") {
        target.textContent = `${data.balance_rub.toFixed(2)} ₽`
      } else {
        target.textContent = data.formatted_balance
      }
    })
  }
}
